var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"content"},[(_vm.ellipsis)?_c('a-tooltip',{attrs:{"title":_vm.title,"placement":"topLeft"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):[_vm._v(_vm._s(_vm.title))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }